import { createContext, useContext } from "react";
import type { FollowupProposalView, FollowupReviewSummary } from "../types/followupReviewView";
import { followupBadgeKey } from "../types/followupReviewView";
import type { FollowupProposalActions } from "./useFollowupProposalActions";
import type { ArrivalReceiptCorrection } from "./useArrivalReceiptCorrection";

export type FollowupReviewContextValue =
  | { summary: FollowupReviewSummary; actions: FollowupProposalActions; caseId: number; correction: ArrivalReceiptCorrection }
  | { error: Error };

export const FollowupReviewContext = createContext<FollowupReviewContextValue | null>(null);

/** Proposals on one field, or undefined outside a follow-up context (no badge, or the view failed to build). */
export function useFollowupProposals(recordId: string | undefined, fieldId: string):
  { proposals: FollowupProposalView[]; actions: FollowupProposalActions; locked: boolean } | undefined {
  const context = useContext(FollowupReviewContext);
  if (!context || "error" in context) return undefined;
  const key = followupBadgeKey(fieldId, recordId);
  const proposals = context.summary.badgeIndex.get(key);
  if (!proposals?.length) return undefined;
  return { proposals, actions: context.actions, locked: context.summary.lockedFields.has(key) };
}
